<!-- @prettier -->
<template>
  <ValidationObserver
    v-slot="{ handleSubmit, invalid, pristine }"
    ref="observer"
  >
    <form
      novalidate
      name="changePasswordForm"
      class="form-horizontal"
      @submit.prevent="handleSubmit(changePassword)"
    >
      <div class="container-fluid">
        <fieldset class="m-t-15">
          <legend class="m-l-20">
            {{ $t('CHANGE_PASSWORD_TITLE') }}
          </legend>
          <div class="form-group">
            <label class="col-sm-3 col-md-3 control-label">{{ $t('CHANGE_PASSWORD_OLD_PASSWORD_LABEL') }}
              <a
                v-tooltip="$t('CHANGE_PASSWORD_OLD_PASSWORD_TT')"
                class="tooltip-icon"
              >
                <i class="fa m-l-3 fa-question-circle" />
              </a>
            </label>
            <ValidationProvider
              v-slot="{ errors, classes }"
              rules="required"
              name="Current Password"
            >
              <div
                class="col-sm-4 col-md-3"
                :class="classes"
              >
                <input
                  v-model="changeRequest.oldPassword"
                  type="password"
                  name="oldPassword"
                  class="form-control"
                  :placeholder="$t('CHANGE_PASSWORD_OLD_PASSWORD_PH')"
                >
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>

          <div class="form-group">
            <label class="col-sm-3 col-md-3 control-label">{{ $t('CHANGE_PASSWORD_NEW_PASSWORD_LABEL') }}
              <a
                v-tooltip="$t('CHANGE_PASSWORD_NEW_PASSWORD_TT')"
                class="tooltip-icon"
              >
                <i class="fa m-l-3 fa-question-circle" />
              </a>
            </label>
            <ValidationProvider
              v-slot="{ errors, classes }"
              name="New Password"
              rules="required|passwordLength|password"
            >
              <div
                class="col-sm-4 col-md-3"
                :class="classes"
              >
                <input
                  v-model="changeRequest.password"
                  type="password"
                  class="form-control"
                  :placeholder="$t('CHANGE_PASSWORD_NEW_PASSWORD_PH')"
                  name="password"
                >
                <span
                  class="text-danger"
                  data-testid="passwordError"
                >{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>



          <div class="form-group">
            <label class="col-sm-3 col-md-3 control-label">{{ $t('CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_LABEL') }}
              <a
                v-tooltip="$t('CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_TT')"
                class="tooltip-icon"
              >
                <i class="fa m-l-3 fa-question-circle" />
              </a>
            </label>
            <ValidationProvider
              v-slot="{ errors, classes }"
              name="Confirm Password"
              rules="required|passwordMatch:@New Password"
            >
              <div
                class="col-sm-4 col-md-3"
                :class="classes"
              >
                <input
                  v-model="changeRequest.confirmPassword"
                  type="password"
                  class="form-control"
                  :placeholder="$t('CHANGE_PASSWORD_CONFIRM_NEW_PASSWORD_PH')"
                  name="confirmPassword"
                >
                <span
                  class="text-danger"
                  data-testid="confirmPasswordError"
                >{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>

          <div class="form-group">
            <div class="col-md-offset-3 col-sm-offset-3 col-md-8 col-sm-8">
              <PrimaryButton
                type="submit"
                size-class="btn-lg"
                :show-loader-on-form="isUpdating"
                :disabled="pristine || invalid"
              >
                {{ $t('CHANGE_PASSWORD_BUTTON') }}
              </PrimaryButton>
            </div>
          </div>
        </fieldset>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import sharedMessages from '@/core/locales';
import messages from '../locales';
import PrimaryButton from '@/core/components/PrimaryButton';
import { ringbaUserService, utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'ChangePassword',
  components: {
    PrimaryButton,
  },
  data: () => ({
    isUpdating: false,
    changeRequest: {
      oldPassword: '',
      password: '',
      confirmPassword: ''
    },
  }),
  methods: {
    async changePassword() {
      try {
        await ringbaUserService.changePassword(this.changeRequest);
        utilities.showToaster('success', this.$t('CHANGE_PASSWORD_SUCCESS'));
        this._resetForm();

      } catch (error) {
        utilities.errorHandler(error);  
      }
    },

    _resetForm() {
      this.changeRequest = {
        oldPassword: '',
        password: '',
        confirmPassword: ''
      };
      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>